import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { InvoiceService } from 'src/app/service/Invoice.service';

export interface InvoiceItem {
  description: string;
  patient?: string;
  quantity: number;
  unitPrice: number;
  tva: number;
}

export interface Invoice {
    id?: number; // ✅ AJOUT IMPORTANT
  number: string;
  date: string;
  seller: {
    name: string;
    address: string;
    siret: string;
    tva: string;
  };
  buyer: {
    name: string;
    city: string;
    address: string;
    tva: string;
    phone: string;
  };
  items: InvoiceItem[];
  bank: {
    name: string;
    rib: string;
    iban: string;
    bic: string;
  };
}


@Component({
  selector: 'app-facturation',
  templateUrl: './facturation.component.html',
  styleUrls: ['./facturation.component.scss'],
})



export class FacturationComponent implements OnInit {

  invoice: Invoice = {
    number: '2026-002',
    date: '2026-01-19',
    seller: {
      name: 'BASF B AND SMILE',
      address: '480 ROUTE DES PENETS\n74140 LOISIN',
      siret: '503 322 034 00037',
      tva: 'FR94503322034'
    },
    buyer: {
      name: '',
      city: '',
      address: '',
      tva: '',
      phone: ''
    },
    items: [
      // { description: 'RCC 1 VERIN', patient: 'PATIENT xxxxx', quantity: 1, unitPrice: 120, tva: 20 }
    ],
    bank: {
      name: 'LCL',
      rib: '30002 03943 00007 1253V 47',
      iban: 'FR38 3000 2039 4300 0007 1253 V47',
      bic: 'CRLYFRPP'
    }
  };
  constructor(
        private invoiceService: InvoiceService,
  ) { }
  @Output() close = new EventEmitter<void>();
@Input() idInvoice: number | null = null;
 @Input() selectedPatient:any = null;
  ngOnInit() {
      console.log('idInvoice',this.idInvoice);
if (this.idInvoice) {
  this.invoiceService.getById(this.idInvoice).subscribe({
    next: (data) => {
      this.invoice = data;
console.log("invoice",this.invoice);

      if (!this.invoice.items || this.invoice.items.length === 0) {
        this.invoice.items = [this.createDefaultItem()];
      }
    },
  });
}
  }

    getItemTotal(i: InvoiceItem) {
    return i.quantity * i.unitPrice;
  }

createDefaultItem(): InvoiceItem {
  return {
    description: '',
    patient: this.selectedPatient || '',
    quantity: 1,
    unitPrice: 0,
    tva: 20
  };
}
  mapFromBackend(data: any): Invoice {
  return {
    id: data.id,
    number: data.number,
    date: data.date,

    seller: {
      name: data.sellerName,
      address: data.sellerAddress,
      siret: data.sellerSiret,
      tva: data.sellerTva
    },

    buyer: {
      name: data.buyerName,
      city: data.buyerCity,
      address: data.buyerAddress,
      tva: data.buyerTva,
      phone: data.buyerPhone
    },

    items: data.items || [],

    bank: {
      name: data.bankName,
      rib: data.bankRib,
      iban: data.bankIban,
      bic: data.bankBic
    }
  };
}
closeModal() {
    this.close.emit();
}
@ViewChild('invoiceContent', { static: false }) invoiceContent!: ElementRef;
print() {
  const content = this.invoiceContent.nativeElement.innerHTML;

  const printWindow = window.open('', '', 'width=900,height=700');

  printWindow!.document.write(`
    <html>
      <head>
        <title>Facture N°${this.invoice.number}</title>
         <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" rel="stylesheet">
        <style>
        table{
        font-size: 12px !important;
        }
          body {
           font-family: 'Roboto', Arial, sans-serif; 
            padding: 20px;
            font-size: 12px !important;
            }

            .invoice {
              width: 210mm;
              min-height: 297mm;
              background: #fff;
              margin: auto;
              padding: 15mm;
              font-size: 12px !important;
              color: #000;
            }

            /* HEADER */
            .header-table td {
              width: 50%;
              vertical-align: top;
            }


            .header-table {
              width: 100%;
            }

            .buyer {
              text-align: right;
            }

            /* DATE */
            .date-table {
              width: 50%;
              margin: 20px 0;
            }

            .date-table td {
              border: 1px solid #bfbfbf;
              padding: 8px;
            }

            .date-table .label {
              background: #a8b4d6;
              font-weight: bold;
            }

            /* ITEMS */
            .items-table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
              table-layout: fixed;
            }

            .items-table th {
              background: #a8b4d6;
              border: 1px solid #bfbfbf;
              padding: 8px;
            }

            .items-table td {
              border: 1px solid #bfbfbf;
              padding: 8px;
              text-align: center;
            }

            .items-table td:first-child {
              text-align: left;
            }

            /* TOTALS */
            .totals-table {
              width: 40%;
              float: right;
              margin-top: 20px;
            }

            .totals-table td {
              border: 1px solid #bfbfbf;
              padding: 10px;
            }

            .totals-table .label {
              background: #a8b4d6;
              font-weight: bold;
            }

            .bold {
              font-weight: bold;
            }

            /* BANK */
            .bank {
              margin-top: 50px;
              font-size: 12px;
              text-align: left;
            }
              table {
              border-collapse: collapse;
              margin: 0;
            }
            .col-desc { width: 45%; }
            .col-qty { width: 10%; }
            .col-price { width: 20%; }
            .col-tva { width: 10%; }
            .col-total { width: 20%; }

          * {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .no-print {
            display: none !important;
          }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);

  printWindow!.document.close();
  printWindow!.focus();
  printWindow!.print();
  printWindow!.close();
}

}


